import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { NodeSpecsModal, NodeSpecsJsonModal, ConductanceMatrixModal, ThermalConductivityJsonModal, CustomMaterialModal, SurfaceThresholdsModal } from "./modals";

import { useThermalDesign } from "../../ThermalDesignContext";
import { useThermalConfigLoader } from "./hooks/ThermalDesignerHooks";
import { ThermalSettingsBtn } from "./components";

const ThermalDesigner = () => {
  const { mission_id, sat_id } = useParams();
  const { openModal, setIsSatDesignerSidebarOpen } = useThermalDesign();
  const { loadThermalConfig } = useThermalConfigLoader();

  useEffect(() => {
    if (mission_id && sat_id) {
      loadThermalConfig(mission_id, sat_id);
    }
  }, [mission_id, sat_id, loadThermalConfig]);

  // When all modals are closed, restore the sidebar
  useEffect(() => {
    if (!Object.values(openModal).some(Boolean)) {
      setIsSatDesignerSidebarOpen(true);
    }
  }, [openModal, setIsSatDesignerSidebarOpen]);

  const anyModalOpen = Object.values(openModal).some(Boolean);

  return (
    <div>
      {anyModalOpen && <ThermalSettingsBtn />}
      {openModal.isNodeSpecsModalOpen && <NodeSpecsModal />}
      {openModal.isNodeSpecsJsonModalOpen && <NodeSpecsJsonModal />}
      {openModal.isThermalConductivityModalOpen && <ConductanceMatrixModal />}
      {openModal.isThermalConductivityJsonModalOpen && <ThermalConductivityJsonModal />}
      {openModal.isCustomMaterialModalOpen && <CustomMaterialModal />}
      {/* Upcoming feature */}
      {/* {openModal.isSurfaceThresholdsModalOpen && <SurfaceThresholdsModal />} */}
    </div>
  );
};

export default ThermalDesigner;
